<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="clipped"
      app
      enable-resize-watcher
      fixed
      persistent
    >
      <stroll-navigation-list :strolls="strolls" />
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="clipped"
      class="toolbar"
      app
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"/>
      <transition name="fade">
        <img
          v-if="getImageSrc"
          :src="getImageSrc"
          :title="getAppTitle"
          style="height: 50px"
        >
        <v-toolbar-title
          v-else
          v-text="getAppTitle"
        />
      </transition>
    </v-toolbar>
    <v-content style="min-height: 100vh;">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StrollNavigationList from '@/components/StrollNavigationList.vue'

export default {
  name: 'App',

  components: {
    StrollNavigationList,
  },

  data () {
    return {
      clipped: true,
      drawer: false,
      title: 'Strollopia',
      image: null,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'getSettings',
      strolls: 'getStrolls',
      strollWording: 'getStrollWording',
    }),

    getAppTitle() {
      if (this.settings && this.settings.display_name) {
        return this.settings.display_name
      }
      return this.title
    },

    getImageSrc() {
      if (this.settings && this.settings.logo_thumbnail) {
        return this.settings.logo_thumbnail.url
      }
      return null
    }
  },

  async created() {
    await this.fetchSettings()
    await this.fetchStrolls()
    await this.fetchLocation()
  },

  watch: {
    // Set HTML title
    settings: function(newSettings) {
      if (newSettings.display_name) {
        document.title = newSettings.display_name
      }
    }
  },

  methods: {
    ...mapActions([
      'fetchLocation',
      'fetchSettings',
      'fetchStrolls',
    ]),
  },
}
</script>

<style lang="sass">
html
  overflow-y: auto

.application--wrap
  min-height: -webkit-fill-available !important

.toolbar
  z-index: 3

.vue2leaflet-map.leaflet-container
  z-index: 2

audio
  width: 100%

audio, video
  max-width: 100%

.full-height
  height: 100%

.fade-enter-active,
.fade-leave-active
  transition: opacity .2s

.fade-enter,
.fade-leave-to
  opacity: 0

.text-black
  color: black
</style>
